import React from "react";
import { Row, Col, Form, Input } from "antd";
import BannerCard from "../../../common/components/BannerCard";
import CleanButton from "../../../common/components/CleanButton";

const RecoverPasswordForm = ({ ...props }) => {
  const { recoverPasswordForm, recoverPasswordLoading, handleRecoverClick, handleOnCancelClick } = props;

  return (
    <Form layout="vertical" form={recoverPasswordForm}>
      <Col xl={8} lg={10} md={24} sm={24} xs={24}>
        <BannerCard title="Enter Account Information">
          <br />
          <Row gutter={[12, 12]}>
            <Col xl={24} lg={24} md={24} sm={24} xs={24}>
              <span>Include all preceding zeros, asterisks, and periods in your account number. You must type the service address exactly as it appears on your bill.</span>
            </Col>
            <Col xl={24} lg={24} md={24} sm={24} xs={24}>
              <Form.Item label="Agency ID" name="AGENCY_ID" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col xl={24} lg={24} md={24} sm={24} xs={24}>
              <Form.Item label="Reference Code" name="REFERENCE_CODE" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col>
              <CleanButton icon="check" onClick={handleRecoverClick} loading={recoverPasswordLoading}>
                Continue
              </CleanButton>
            </Col>
            <Col>
              <CleanButton icon="times" onClick={handleOnCancelClick}>
                Cancel
              </CleanButton>
            </Col>
          </Row>
        </BannerCard>
      </Col>
    </Form>
  );
};

export default RecoverPasswordForm;
